import { defineComponent as _defineComponent } from 'vue'
import { TipoObra } from '@/constants';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';
import { TextValue } from '@/types/common';
import { ColecaoPeriodicoVolume } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TabelaArtigos',
  setup(__props) {

const store = ConsultaObrasStore();
const { obraTempImpressao: obra, listaPeriodicos } = storeToRefs(store);

const items = computed(() =>
  listaPeriodicos.value
    ? listaPeriodicos.value
    : obra.value!.artigoPeriodicoList
);

const itemsSelect = computed(
  () =>
    obra.value?.colecaoPeriodicoVolumeList?.map((item) => ({
      text: getLabel(item) ?? '',
      value: item.cdColecaoPeriodicoVolume,
    })) ?? []
);

const selected = ref<TextValue>();

onMounted(() => {
  if (items.value?.length) {
    selected.value = itemsSelect.value[0];
  }
});

const getLabel = (item: ColecaoPeriodicoVolume) => {
  if (item.deVolume && item.deNumero) {
    return `${item.deVolume}/${item.deNumero}`;
  }

  return item.deVolume ?? item.deNumero;
};

return { __sfc: true,store, obra, listaPeriodicos, items, itemsSelect, selected, getLabel, TipoObra }
}

})